import getUrlParam, { decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';

const validateParameter = (parameter) => {
  let value = '';
  let urlParameter = getUrlParam(parameter);
  if (urlParameter) {
    value = decodeUrlQueryValue(urlParameter);
  }
  return value;
};

export default validateParameter;
